import { createEffect, splitProps } from "solid-js";
import { createFormControl } from "solid-forms";
import type { MainProps } from "./_model";
import type { FormControlData, FormControlValue } from "../SHARED/_model";

export default function <V extends FormControlValue, D extends FormControlData>(props: MainProps<V, D>) {
  const [local, others] = splitProps(props, ["control", "onChange", "update", "type", "children"]);
  const _control = Array.isArray(local.control) ? createFormControl<V, D>(...local.control) : local.control;
  const control_is_array = Array.isArray(local.control);

  createEffect(() => {
    if (control_is_array && local.update) {
      _control.setValue(local.control[0]);
    }
  });

  return (
    <div class={`grid grid-cols-[10%_1fr] justify-start items-start ${others.class ?? ""}`}>
      <input
        {...others}
        class={`input ${local.type === "checkbox" ? "checkbox" : "radio"}`}
        type={local.type}
        value={_control.value as any}
        oninput={(e) => {
          let v = e.currentTarget.checked as V;
          if (local.type === "radio") {
            v = e.currentTarget.id as V;
          } else if (local.type === "checkbox") {
            // v = e.currentTarget.id as V;
            // v = (!e.target.checked ? "false" : "true") as V;
            v = e.target.checked as unknown as V;
            // console.log("form ype is :: ", type, v);
          }

          // console.log("value form is :: ", v);
          _control.setValue(v);
          if (_control.isValid) {
            if (local.onChange) {
              local.onChange(v);
            }
          }
        }}
        classList={{
          invalid: !!_control.errors,
          touched: _control.isTouched,
          disabled: _control.isDisabled,
          required: _control.isRequired,
          ...others.classList,
        }}
        onblur={() => _control.markTouched(true)}
        onfocus={() => _control.markTouched(true)}
        onfocusin={() => _control.markTouched(true)}
        onfocusout={() => _control.markTouched(false)}
        disabled={_control.isDisabled}
        required={_control.isRequired}
      />
      <div class="children">{local.children}</div>
    </div>
  );
}
